import React from "react";
import { withRouter } from "react-router-dom";

import { Button } from "react-bootstrap";

import styles from "./style.module.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagic, faCheckCircle } from "@fortawesome/free-solid-svg-icons";

export default class CostsBlueprint extends React.PureComponent {
  render() {
    const { blueprint } = this.props;

    return <div className={styles.blueprint}>{"hello"}</div>;
  }
}
